import Vue from 'vue'
import Router from 'vue-router'
import DigitalCard from './views/DigitalCard.vue'
import HomeView from './views/HomeView.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:key',
      name: 'DigitalCard',
      component: DigitalCard
    },
    {
      path: '/HomeView',
      name: 'HomeView',
      component: HomeView
    }
    
  ]
})
